import { Playground } from 'docz';
import { useStorage } from "../../../../../src/index";
import * as React from 'react';
export default {
  Playground,
  useStorage,
  React
};